import classNames from 'classnames/bind'
import React from 'react'
import {ASSET_URL} from '../../'

export const Image = ({src, ...rest}) => (
    <img {...rest} src={ASSET_URL + src}  />
)

export const Vector = ({src, ...rest}) => (
    <img {...rest} src={`${ASSET_URL}/images/${src}.svg`} />
)

export const Message = ({title, text, children}) => (
    <div className="auth__message">
        <div className="auth__message--title">{title}</div>
        <p className="auth__message--text">{text}</p>
        {children}
    </div>
)

export const Heading = ({title, subtitle}) => (
    <div className="auth__heading">
        <div className="auth__heading-title">{title}</div>
        <div className="auth__heading-subtitle">{subtitle}</div>
    </div>
)

export const Panel = ({children, ...rest}) => (
    <div {...rest} className="auth__panel">
        <div className="auth__sign-in">
            {children}
        </div>
    </div>
)

export const Button = (props) => (
    <input className="auth__form-submit" {...props} />
)

export const LinkButton = ({value, children, ...rest}) => (
    <a className="auth__form-submit auth__form-submit-link" {...rest}>
        {value}{children}
    </a>
)

export const Column = ({children, picture}) => (
    <div className={classNames('auth__column', {'auth__column--pic': picture != undefined})}>
        {children}
    </div>
)
